// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"472":"424b289187625c19","2509":"b9113a4ed245697e","9341":"89e743dc7050edf7"}[chunkId] + ".js";
};